import React, { Component } from "react";
import "./Tracer.css";
import { Link } from "react-router-dom";
import Header from '../header/Header';
import Footer from '../footer/Footer';
const watsonBox = require("../../assets/img/box.png");
const watsonMap = require("../../assets/img/map.png");

class Tracer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHome: false,
      isInspectr: true
    };
  }

  render() {
    return (
      <div className="inspectr-container">
        <div className="inspectr-header">
        <Header/>
        </div>

        <div className="inspectr-hero">
          <div className="inspectr-about">
            <div className="header">About TraceR</div>
            <div className="text">
              Supply chain management (SCM) is an integral part of any business
              operations. Consistency, transparency and optimization of your SCM
              operations can significantly improve the quality, delivery and
              total costs of products. Our solution TraceR, aims to provide
              insights into the end-to-end process using Internet-of-Things
              (IoT) sensor data and Blockchain (Coldchain) technology. 
            </div>
          </div>

          <div id="mybutton">
            <button className="feedback">Contact</button>
          </div>

          <div className="inspectr-solutions">
            <div className="header">Applications </div>
            <div className="solution-wrapper">

            <Link target="_blank" to="http://iotcoldchain.mybluemix.net/">
              <div className="tracer-solution-container"> 
                <div className="box">  
                    <img className="tracer-image" src={watsonBox}/>  
                    <span className="solution-description fade-solution-description">  
                    <h3>Cold Chain</h3>  
                    <p> Integrating blockchain technology into supply chain to understand and trace the temperature of products from suppliers to shelf.</p>  
                    </span>  
                </div>
                <div className="solution-title">Cold Chain</div>
              </div>
            </Link>

            <Link target="_blank" to="https://supply-chain-dashboard.mybluemix.net/#!/">
              <div className="tracer-solution-container"> 
                <div className="box">  
                    <img className="tracer-image" src={watsonMap}/>  
                    <span className="solution-description fade-solution-description">  
                    <h3>Supply Chain</h3>  
                    <p>Basic supply chain tracking using IoT sensors understanding GPS location, handler, type of package, etc. </p>  
                    </span>  
                </div>
                <div className="solution-title">Supply Chain</div>
              </div>
            </Link>
            </div>
          </div>

          <Footer />
          
        </div>
      </div>
    );
  }
}

export default Tracer;



// WEBPACK FOOTER //
// src/components/tracer/Tracer.js